module.exports = __webpack_public_path__ + "img/receipt.e4e38860.svg";